(function () {
  var TIERS = [
    { min: 5,  discount: 5  },
    { min: 10, discount: 10 },
    { min: 20, discount: 15 }
  ];

  function getNextTier(totalQty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (totalQty < TIERS[i].min) return TIERS[i];
    }
    return null;
  }

  function getProgress(totalQty) {
    if (totalQty < 5)  return Math.min(totalQty / 5 * 100, 100);
    if (totalQty < 10) return Math.min((totalQty - 5) / 5 * 100, 100);
    if (totalQty < 20) return Math.min((totalQty - 10) / 10 * 100, 100);
    return 100;
  }

  function renderTierBar(totalQty) {
    var bar = document.querySelector('[data-cart-tier-bar]');
    if (!bar) return;

    var nextTier = getNextTier(totalQty);

    if (!nextTier) {
      bar.innerHTML =
        '<p class="cart-tier-bar__message cart-tier-bar__message--reached">' +
        'Congratulazioni! Hai sbloccato il miglior sconto: <strong>-15%</strong>' +
        '</p>';
      return;
    }

    var needed = nextTier.min - totalQty;
    var progress = getProgress(totalQty);
    var singular = needed === 1;

    bar.innerHTML =
      '<p class="cart-tier-bar__message">' +
      'Aggiungi <strong>' + needed + ' articol' + (singular ? 'o' : 'i') + ' in più</strong>' +
      ' per sbloccare <strong>-' + nextTier.discount + '%</strong>' +
      ' a partire da ' + nextTier.min + ' articoli' +
      '</p>' +
      '<div class="cart-tier-bar__track">' +
      '<div class="cart-tier-bar__fill" style="--progress: ' + progress + '%"></div>' +
      '</div>';
  }

  function getTotalQty(cartData) {
    var total = 0;
    if (cartData && cartData.items) {
      for (var i = 0; i < cartData.items.length; i++) {
        total += cartData.items[i].quantity;
      }
    }
    return total;
  }

  // empire.js dispatches this after every cart quantity change
  window.addEventListener('cartcount:update', function (e) {
    renderTierBar(getTotalQty(e.detail));
  });

  // Collection filter dropdown (toggled next to "Trier par")
  function closeFilterDropdown(wrapper) {
    var trigger = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]');
    var panel = wrapper.querySelector('[data-productgrid-filter-dropdown]');
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openFilterDropdown(wrapper) {
    var trigger = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]');
    var panel = wrapper.querySelector('[data-productgrid-filter-dropdown]');
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');

    if (!panel.dataset.expanded) {
      panel.dataset.expanded = 'true';
      requestAnimationFrame(function () {
        panel.querySelectorAll('[data-filter-group-trigger][aria-expanded="false"]').forEach(function (groupTrigger) {
          groupTrigger.click();
        });
      });
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-productgrid-filter-dropdown-trigger]');
    var wrappers = document.querySelectorAll('[data-productgrid-filter-dropdown-wrapper]');

    if (trigger) {
      var wrapper = trigger.closest('[data-productgrid-filter-dropdown-wrapper]');
      var isOpen = wrapper.querySelector('[data-productgrid-filter-dropdown-trigger]').getAttribute('aria-expanded') === 'true';

      wrappers.forEach(function (w) {
        closeFilterDropdown(w);
      });

      if (!isOpen) {
        openFilterDropdown(wrapper);
      }
      return;
    }

    if (!e.target.closest('[data-productgrid-filter-dropdown]')) {
      wrappers.forEach(function (w) {
        closeFilterDropdown(w);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-productgrid-filter-dropdown-wrapper]').forEach(function (w) {
      closeFilterDropdown(w);
    });
  });
})();
